const voltApi = await import("@ifs/volt-api/build/att.bundle.js");
export default voltApi;